var _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUkFlag(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_576_2613",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 26,
    height: 25
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 25C20.1797 25 26 19.4036 26 12.5C26 5.59644 20.1797 0 13 0C5.8203 0 0 5.59644 0 12.5C0 19.4036 5.8203 25 13 25Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_576_2613)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0L0.40625 1.07422L0 2.19727V3.32031L1.625 5.95703L0 8.59375V10.1562L1.625 12.5L0 14.8438V16.4062L1.625 19.043L0 21.6797V25L1.11719 24.6094L2.28516 25H3.45312L6.19531 23.4375L8.9375 25H10.5625L13 23.4375L15.4375 25H17.0625L19.8047 23.4375L22.5469 25H26L25.5938 23.9258L26 22.8027V21.6797L24.375 19.043L26 16.4062V14.8438L24.375 12.5L26 10.1562V8.59375L24.375 5.95703L26 3.32031V0L24.8828 0.390625L23.7148 0H22.5469L19.8047 1.5625L17.0625 0H15.4375L13 1.5625L10.5625 0H8.9375L6.19531 1.5625L3.45312 0H0Z",
    fill: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0625 0V5.27344L22.5469 0H17.0625ZM26 3.32031L20.5156 8.59375H26V3.32031ZM0 8.59375H5.48438L0 3.32031V8.59375ZM3.45312 0L8.9375 5.27344V0H3.45312ZM8.9375 25V19.7266L3.45312 25H8.9375ZM0 21.6797L5.48438 16.4062H0V21.6797ZM26 16.4062H20.5156L26 21.6797V16.4062ZM22.5469 25L17.0625 19.7266V25H22.5469Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0V2.19727L6.65234 8.59375H8.9375L0 0ZM10.5625 0V10.1562H0V14.8438H10.5625V25H15.4375V14.8438H26V10.1562H15.4375V0H10.5625ZM23.7148 0L17.0625 6.39648V8.59375L26 0H23.7148ZM8.9375 16.4062L0 25H2.28516L8.9375 18.6035V16.4062ZM17.0625 16.4062L26 25V22.8027L19.3477 16.4062H17.0625Z",
    fill: "#D80027"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUkFlag);
export default __webpack_public_path__ + "static/media/uk_flag.5ddbe9d9c1b82f872a38b5a44c512f39.svg";
export { ForwardRef as ReactComponent };